import { PROMOS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";
import { normalizeResponse } from "../normalizeResponse";

const porId = (promoId) => PROMOS.promoById.replace("{promoId}", encodeURIComponent(promoId));

export const fetchCreatePromo = async (body) => {
  const response = await ApiRequestInterceptor(PROMOS.promos, "POST", body);
  return normalizeResponse(response, "No se pudo crear la promo");
};

export const fetchUpdatePromo = async (promoId, body) => {
  const response = await ApiRequestInterceptor(porId(promoId), "PUT", body);
  return normalizeResponse(response, "No se pudo guardar la promo");
};

export const fetchDeletePromo = async (promoId) => {
  const response = await ApiRequestInterceptor(porId(promoId), "DELETE");
  return normalizeResponse(response, "No se pudo eliminar la promo");
};
